import { NgModule } from '@angular/core';

import { MasterSearchUserActions } from './master-search-user.actions';
import { EditarAction } from './master-editar-search-user.action';

@NgModule({
  providers: [
      EditarAction,
    MasterSearchUserActions
  ]
})
export class MasterSearchUserActionsModule {}
